import { render, staticRenderFns } from "./ManageRecipient.vue?vue&type=template&id=0082174a"
import script from "./ManageRecipient.vue?vue&type=script&lang=js"
export * from "./ManageRecipient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports